import React from 'react'
import ScheduleContextMenuDayBadge from './ScheduleContextMenuDayBadge'
import { FaIcon, faThumbtackAngleSolid } from '@/lib/fa'
import ScheduleContextMenuDayLabel from './ScheduleContextMenuDayLabel'
import useDayTypesService from '@/modules/drivers/services/DayTypesService'
import { LoaderIcon } from '@/app/features/icons/Loader'

const ScheduleContextMenuOption = ({
  dayType,
  changeDayType,
  companyId,
  searchQuery = '',
  isSelected = false,
  isPinned = false,
  onPinToggle,
}) => {
  const { removePinDay, addPinDay } = useDayTypesService()
  const [isPinLoading, setIsPinLoading] = React.useState(false)
  const handlePinClick = async (e) => {
    e.stopPropagation()
    setIsPinLoading(true)
    try {
      if (isPinned) {
        await removePinDay({ companyId, dayTypeId: dayType })
      } else {
        await addPinDay({ companyId, dayTypeId: dayType })
      }
      await onPinToggle?.()
    } catch (error) {
      console.error('Error updating pinned day:', error)
    } finally {
      setIsPinLoading(false)
    }
  }
  return (
    <div
      key={dayType}
      onClick={() => changeDayType(dayType)}
      className={`tw-flex-gap-2 tw-flex tw-cursor-pointer tw-items-center tw-justify-between tw-rounded tw-px-1 tw-py-2 hover:tw-bg-base-200 ${isSelected && 'tw-bg-base-200'}`}
    >
      <div className="tw-flex tw-items-center tw-gap-2">
        <ScheduleContextMenuDayBadge
          dayType={dayType}
          searchQuery={searchQuery}
        />
        <ScheduleContextMenuDayLabel
          isSelected={isSelected}
          dayType={dayType}
          searchQuery={searchQuery}
        />
      </div>

      {isPinLoading ? (
        <LoaderIcon className="tw-h-4 tw-w-4 tw-animate-spin tw-pr-4 tw-text-primary" />
      ) : (
        <FaIcon
          onClick={(e) => handlePinClick(e)}
          icon={faThumbtackAngleSolid}
          className={`tw-h-4 tw-w-4 tw-cursor-pointer tw-pr-4 hover:tw-text-primary ${isPinned ? 'tw-text-primary' : 'tw-text-base-300'}`}
        />
      )}
    </div>
  )
}

export default ScheduleContextMenuOption
